var _g, _defs;

const _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgStep2(_ref, svgRef) {
  let {
    title,
    titleId
  } = _ref,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 162,
    height: 162,
    fill: "none",
    viewBox: "0 0 162 162",
    xmlSpace: "preserve",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_5464_4282)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 16,
    y: 12,
    width: 130,
    height: 130,
    rx: 16,
    fill: "#51587D"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m119 101.48h-50.952v0.219h50.952v-0.219z",
    fill: "#3F3D56"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m79.083 47.626h-0.3922v-10.706c0-0.8137-0.1608-1.6195-0.4733-2.3713s-0.7705-1.4349-1.3478-2.0103c-0.5774-0.5754-1.2628-1.0318-2.0172-1.3432s-1.5629-0.4717-2.3794-0.4717h-22.76c-0.8166 0-1.6251 0.1603-2.3795 0.4717-0.7543 0.3114-1.4398 0.7678-2.0171 1.3432-0.5774 0.5754-1.0354 1.2585-1.3479 2.0103s-0.4733 1.5576-0.4733 2.3713v58.735c0 0.8138 0.1608 1.6196 0.4733 2.3713 0.3125 0.7518 0.7705 1.4349 1.3479 2.0104 0.5773 0.575 1.2628 1.032 2.0171 1.343 0.7544 0.312 1.5629 0.472 2.3795 0.472h22.76c0.8165 0 1.625-0.16 2.3794-0.472 0.7544-0.311 1.4398-0.768 2.0172-1.343 0.5773-0.5755 1.0353-1.2586 1.3478-2.0104 0.3125-0.7517 0.4733-1.5575 0.4733-2.3713v-40.408h0.3922v-7.6208z",
    fill: "#3F3D56"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m72.724 32.336h-2.971c0.1366 0.3338 0.1888 0.696 0.1519 1.0546-0.0369 0.3587-0.1618 0.7028-0.3636 1.002s-0.4743 0.5444-0.7936 0.714c-0.3192 0.1695-0.6754 0.2582-1.0372 0.2582h-13.039c-0.3618 0-0.718-0.0887-1.0373-0.2582-0.3192-0.1696-0.5918-0.4148-0.7935-0.714-0.2018-0.2992-0.3267-0.6433-0.3636-1.002-0.0369-0.3586 0.0153-0.7208 0.1519-1.0546h-2.7749c-0.6098 0-1.2136 0.1197-1.777 0.3522-0.5633 0.2326-1.0752 0.5734-1.5064 1.0031-0.4311 0.4297-0.7732 0.9399-1.0065 1.5013-0.2334 0.5614-0.3535 1.1632-0.3535 1.7708v58.649c0 0.6077 0.1201 1.2094 0.3535 1.7709 0.2333 0.5614 0.5754 1.0715 1.0065 1.5012 0.4312 0.4297 0.9431 0.7706 1.5064 1.0031 0.5634 0.2326 1.1672 0.3526 1.777 0.3526h22.87c0.6098 0 1.2136-0.12 1.7769-0.3526 0.5634-0.2325 1.0753-0.5734 1.5064-1.0031 0.4312-0.4297 0.7732-0.9398 1.0066-1.5012 0.2333-0.5615 0.3534-1.1632 0.3534-1.7709v-58.649c0-1.2272-0.4892-2.4042-1.36-3.2721-0.8708-0.8678-2.0518-1.3553-3.2833-1.3553z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m111.24 112.38 2.415 0.772-3.092 7.134-1.636-0.522 2.313-7.384z",
    fill: "#A0616A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m111.65 118.07-0.964 0.06-0.19 0.498s0.023-0.652-0.991-1.185l-0.312 0.434s-0.594 0.315-0.851 1.198l-0.609 2.395 0.809 0.289 0.741-1.545s0.359-0.277 0.717 1.832c0 0 1.012 0.712 2.97 0.796 0.269 0.011 0.52-0.148 0.613-0.4 0.052-0.14 0.047-0.289-0.11-0.402-0.398-0.287-0.887-0.304-1.038-0.767-0.15-0.464-0.785-3.203-0.785-3.203z",
    fill: "#2F2E41"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m94.498 111.14-2.4563 0.629 2.6679 7.303 1.6645-0.425-1.8761-7.507z",
    fill: "#A0616A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m93.758 116.79 0.9591 0.116 0.1602 0.508s0.0154-0.652 1.0595-1.125l0.2859 0.451s0.5741 0.35 0.7793 1.246l0.4668 2.427-0.8241 0.241-0.6491-1.586s-0.3427-0.298-0.8234 1.787c0 0-1.052 0.652-3.0114 0.62-0.2693-4e-3 -0.5105-0.177-0.5889-0.435-0.0432-0.142-0.0294-0.291 0.1333-0.394 0.4142-0.263 0.9039-0.252 1.0812-0.706 0.1774-0.453 0.9716-3.15 0.9716-3.15z",
    fill: "#2F2E41"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m100.55 81.841h6.559v-9.6926h-6.559v9.6926z",
    fill: "#2F2E41"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m105.98 88.646-0.196 5.189-6.4618-0.4896 0.7828-5.091 5.875 0.3916z",
    fill: "#A0616A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m98.835 91.485 9.3012 0.2937 2.321 3.285-1.077 5.7764s-4.671-1.327-12.405 0.24l0.4895-5.3852 1.4933-1.4933-0.1226-2.7166z",
    fill: "#2F2E41"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m108.92 95.401 2.546 1.077s4.797 2.1539 5.091 5.0909-3.201 13.903-3.201 13.903l-3.835 0.229s1.14 0.793 1.14-4.648c0-3.788 1.686-7.428 1.686-7.428s-2.448-4.5035-8.714-3.427c0 0-6.8464-0.2215-10.077 3.89 0 0 1.7105 3.666 1.8327 5.865l0.5057 4.76-3.2308 0.294s-4.6946-12.557-2.6386-15.102c2.056-2.5455 6.4617-4.0141 6.4617-4.0141l12.434-0.4895z",
    fill: "#2F2E41"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m105.64 78.886-0.23-2.7761h-3.054l-0.677 2.9412 3.961-0.1651z",
    fill: "#A0616A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m105.64 78.886-0.23-2.7761h-3.054l-0.677 2.9412 3.961-0.1651z",
    fill: "#FDFDFD",
    opacity: 0.1
  }), /*#__PURE__*/React.createElement("path", {
    d: "m106.74 73.654c0 1.844-1.495 3.3388-3.339 3.3388s-3.338-1.4948-3.338-3.3388c0-1.8439 1.494-3.3388 3.338-3.3388s3.339 1.4949 3.339 3.3388z",
    fill: "#A0616A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m101.68 78.464h3.916l0.49 1.077 0.489 10.867s-3.72-0.8812-6.9509-0.7833l0.7829-9.8883 0.979-0.5874 0.294-0.6854z",
    fill: "#DB2323"
  }), /*#__PURE__*/React.createElement("g", {
    fill: "#2F2E41"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m105.4 100.59s1.958-4.4057 2.741-4.5036 2.551 0 2.551 0l-0.397-0.6853s-0.098-1.3707-1.077-1.3707-0.587-14.098-0.587-14.098l-2.743-0.8248s-1.565 4.8388-1.565 9.4404c0 4.6015-0.196 9.6925-0.196 9.6925l1.273 2.3497z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m101.5 78.886-3.4415 0.9483 0.3917 13.511-2.2518 2.7413s2.9371 0 3.6224 2.4476c0 0 0.8132 1.3383 1.6792 1.2076 0.866-0.1306 0.279-2.872 0.279-2.872l-0.881-3.4266 0.098-5.7764 0.504-8.7807z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m102.56 70.142s0-1.3706 1.272-1.0769c1.273 0.2937 1.665 0.7832 1.665 0.7832s0.489 0.7833 1.273 0.8812c0.783 0.0979 1.468 2.3497 1.37 2.8392s-0.587 1.7623 0.098 2.3497 1.665 1.4686 1.371 2.3497c-0.294 0.8812-1.175 3.133-1.175 3.133s2.458 0.3592 2.257 1.8929c0 0-1.18-0.9139-2.747-0.9139-1.566 0-1.37-2.8419-1.37-2.8419s-0.098-1.7596-0.392-2.2491 0.098-3.2309-1.371-4.6994c-1.468-1.4686-2.251-2.4477-2.251-2.4477z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m102.95 69.848s-1.86 0.3916-2.545 2.2518c-0.6855 1.8601-0.339 2.2063-0.339 2.2063s-0.1519 1.1201-0.9835 1.5129c-0.8316 0.3927-0.1463 2.0571-0.1463 2.0571s-0.1958 1.6644-2.8392 2.2518c-2.6434 0.5875-2.056 4.0141-2.056 4.0141s2.1539-3.035 4.8952-3.1329c2.7418-0.0979 2.2518-3.133 2.2518-3.133l-0.294-3.2308s0.588-3.7204 2.35-4.2099-0.294-0.5874-0.294-0.5874z"
  })), /*#__PURE__*/React.createElement("path", {
    d: "m105.6 100.83c-0.077 0.911 0.33 1.689 0.909 1.739 0.58 0.049 1.113-0.649 1.19-1.561 0.036-0.363-0.015-0.73-0.15-1.0696l0.28-3.8634-1.816-0.0928-0.083 3.8186c-0.191 0.3122-0.304 0.6652-0.33 1.0292z",
    fill: "#A0616A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m98.556 100.92c-0.0776 0.911 0.3294 1.689 0.9091 1.738 0.5795 0.05 1.1125-0.649 1.1895-1.56 0.036-0.364-0.015-0.73-0.15-1.07l0.28-3.8633-1.816-0.0928-0.0833 3.8185c-0.1904 0.3116-0.3034 0.6646-0.3293 1.0296z",
    fill: "#A0616A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m107.89 79.981s2.448-0.6853 2.937 0.8811c0.49 1.5665-1.028 10.182-1.028 10.182l-1.419 9.007-3.035-0.5872 1.958-12.042 0.587-7.4407z",
    fill: "#2F2E41"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m100.52 79.853s-2.3724-0.9135-3.0077 0.5997c-0.6353 1.5133 0.0617 10.234 0.0617 10.234l0.5625 9.101 3.0765-0.2981-0.811-12.173 0.118-7.4629z",
    fill: "#2F2E41"
  }), /*#__PURE__*/React.createElement("g", {
    transform: "translate(10,6)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 25,
    height: 24,
    rx: 12,
    fill: "#db2323"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m15.492 15.462v1.5381h-6.8086v-1.3125l3.2197-3.4521c0.3236-0.3601 0.5788-0.6768 0.7656-0.9502 0.1869-0.278 0.3213-0.5264 0.4034-0.7452 0.0866-0.2233 0.1298-0.4352 0.1298-0.6357 0-0.30078-0.0501-0.55827-0.1503-0.77246-0.1003-0.21875-0.2484-0.38737-0.4444-0.50586-0.1914-0.11849-0.4284-0.17774-0.7109-0.17774-0.3008 0-0.5606 0.07292-0.7793 0.21875-0.2142 0.14584-0.3783 0.34863-0.4922 0.6084-0.1094 0.25977-0.1641 0.55371-0.1641 0.88181h-1.9756c0-0.59242 0.14128-1.1347 0.42383-1.6269 0.28255-0.49674 0.68131-0.89095 1.1963-1.1826 0.5149-0.29623 1.1256-0.44434 1.832-0.44434 0.6973 0 1.2852 0.11393 1.7637 0.3418 0.483 0.2233 0.8476 0.54687 1.0937 0.9707 0.2507 0.41927 0.376 0.92057 0.376 1.5039 0 0.32817-0.0524 0.64937-0.1572 0.96387-0.1048 0.3099-0.2552 0.6198-0.4512 0.9297-0.1914 0.3053-0.4238 0.6152-0.6973 0.9297-0.2734 0.3144-0.5765 0.6403-0.9091 0.9775l-1.7295 1.9414z",
    fill: "#fdfdfd"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_5464_4282",
    x: 0,
    y: 0,
    width: 162,
    height: 162,
    colorInterpolationFilters: "sRGB",
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    result: "hardAlpha",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 4
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 8
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.08 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_5464_4282"
  }), /*#__PURE__*/React.createElement("feBlend", {
    in: "SourceGraphic",
    in2: "effect1_dropShadow_5464_4282",
    result: "shape"
  })))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(-155.1 3.6706)"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 202.91,
    y: 45.719,
    width: 26.965,
    height: 6.664,
    rx: 3.2689,
    fill: "#f67416",
    stopColor: "#000000",
    style: {
      InkscapeStroke: "none",
      fontVariationSettings: "normal"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 202.91,
    y: 59.325,
    width: 26.965,
    height: 6.664,
    rx: 3.2689,
    fill: "#e7b008",
    stopColor: "#000000",
    style: {
      InkscapeStroke: "none",
      fontVariationSettings: "normal"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 202.91,
    y: 72.931,
    width: 26.965,
    height: 6.664,
    rx: 3.2689,
    fill: "#114c29",
    stopColor: "#000000",
    style: {
      InkscapeStroke: "none",
      fontVariationSettings: "normal"
    }
  }))));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgStep2);
export default __webpack_public_path__ + "static/media/step2.2596765562853beb0c8001eb28c58e0c.svg";
export { ForwardRef as ReactComponent };